import React from 'react';
import { Outlet } from 'react-router-dom';

import { DashboardLayout } from '@freelancelabs/components';

import Sidebar from './Sidebar';

// Deliberately does not wrap `RedirectMiddleware`: a sidebar there would let someone escape
// the consent/MFA gate through the rail before clearing an entry condition.
const PrivateLayout = () => (
    <DashboardLayout sidebar={<Sidebar />}>
        <Outlet />
    </DashboardLayout>
);

export default PrivateLayout;
